import { z } from "zod";
import updateData from "../../content/homepage-update.json";

const copy = z.string().trim().min(1).max(300);
const destination = z.string().refine((value) => {
  if (/^\/(?!\/)[a-zA-Z0-9/_?=#&.%-]*$/.test(value)) return true;
  try {
    const url = new URL(value);
    return url.protocol === "https:" && !url.username && !url.password;
  } catch {
    return false;
  }
}, "Use an HTTPS URL or a site-relative path");
const link = z.object({ label: copy, url: destination, accessibleLabel: copy.optional() }).strict();

export const homepageUpdateSchema = z.object({
  id: z.string().regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
  enabled: z.boolean(),
  label: copy,
  expiresAt: z.string().datetime({ offset: true }).optional(),
  headline: z.object({ lead: copy.optional(), emphasis: copy, context: copy.optional() }).strict(),
  description: copy,
  logo: z.object({
    src: z.string().regex(/^\/[a-zA-Z0-9/_-]+\.(?:svg|webp|png|jpg)$/),
    alt: copy,
  }).strict().optional(),
  schedule: z.object({ dateTime: z.string().datetime({ offset: true }), label: copy }).strict().optional(),
  location: link.optional(),
  cta: link,
}).strict();

export type HomepageUpdate = z.infer<typeof homepageUpdateSchema>;

export const homepageUpdate = homepageUpdateSchema.parse(updateData);

export function activeHomepageUpdate(update: HomepageUpdate, now = new Date()): HomepageUpdate | null {
  if (!update.enabled || (update.expiresAt && now.getTime() >= Date.parse(update.expiresAt))) return null;
  return update;
}
